import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'srp-link',
  standalone: true,
  imports: [MatCardModule],
  templateUrl: './link.html',
  styleUrl: './link.scss',
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class Link {
  @Input() href = '';
  @Input() target = '';
  @Input() title = '';
  @Input('data-aue-prop') aueProp = '';
  @Input('data-aue-type') aueType = '';
}

